{
  "AGENT_MGMT": {
    "HEADER": "Agenti",
    "HEADER_BTN_TXT": "Přidat agenta",
    "LOADING": "Načítání seznamu agentů",
    "DESCRIPTION": "Agent je člen vašeho týmu zákaznické podpory, který může zobrazovat zprávy uživatelů a reagovat na ně. Seznam níže zobrazuje všechny agenty ve vašem účtu.",
    "LEARN_MORE": "Více o uživatelských rolích",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "Administrátor",
      "AGENT": "Agent"
    },
    "TABS": {
      "ACTIVE": "Aktivní",
      "DEACTIVATED": "Deaktivovaní"
    },
    "DISCONNECT_PHONE": {
      "BUTTON_TEXT": "Odpojit telefon",
      "API": {
        "SUCCESS_MESSAGE": "Telefon agenta byl úspěšně odpojen",
        "ERROR_MESSAGE": "Nepodařilo se odpojit telefon agenta, zkuste to prosím později"
      }
    },
    "REACTIVATE": {
      "BUTTON_TEXT": "Aktivovat",
      "API": {
        "SUCCESS_MESSAGE": "Agent byl úspěšně aktivován",
        "ERROR_MESSAGE": "Nepodařilo se aktivovat agenta, zkuste to prosím později"
      },
      "CONFIRM": {
        "TITLE": "Potvrdit aktivaci",
        "MESSAGE": "Opravdu chcete aktivovat ",
        "YES": "Ano, aktivovat ",
        "NO": "Ne, zrušit "
      }
    },
    "LIST": {
      "404": "K tomuto účtu nejsou přiřazeni žádní agenti",
      "TITLE": "Spravujte agenty ve vašem týmu",
      "DESC": "Můžete přidat/odebrat agenty do vašeho týmu.",
      "NAME": "Název",
      "EMAIL": "E-MAIL",
      "STATUS": "Stav",
      "ACTIONS": "Akce",
      "VERIFIED": "Ověřeno",
      "VERIFICATION_PENDING": "Probíhá ověření",
      "API_ALLOWED": "Přístup k API povolen",
      "DEACTIVATED_ON": "Deaktivován",
      "AVAILABLE_CUSTOM_ROLE": "Dostupná oprávnění vlastních rolí"
    },
    "ADD": {
      "TITLE": "Přidat agenta do vašeho týmu",
      "DESC": "Můžete přidat lidi, kteří budou schopni zvládnout podporu pro vaše schránky.",
      "CANCEL_BUTTON_TEXT": "Zrušit",
      "FORM": {
        "NAME": {
          "LABEL": "Název agenta",
          "PLACEHOLDER": "Zadejte název agenta"
        },
        "AGENT_TYPE": {
          "LABEL": "Typ agenta",
          "PLACEHOLDER": "Vyberte typ",
          "ERROR": "Je vyžadován typ agenta"
        },
        "EMAIL": {
          "LABEL": "E-mailová adresa",
          "PLACEHOLDER": "Zadejte prosím e-mailovou adresu agenta"
        },
        "SUBMIT": "Přidat agenta"
      },
      "API": {
        "SUCCESS_MESSAGE": "Agent byl úspěšně přidán",
        "EXIST_MESSAGE": "E-mail agenta je již používán, zkuste prosím jinou e-mailovou adresu",
        "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Deaktivovat",
      "API": {
        "SUCCESS_MESSAGE": "Agent byl úspěšně deaktivován",
        "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
      },
      "CONFIRM": {
        "TITLE": "Potvrdit deaktivaci",
        "MESSAGE": "Opravdu chcete deaktivovat ",
        "DESCRIPTION": "Agent bude okamžitě odhlášen, odebrán ze všech týmů a inboxů a nebude moci přistupovat k tomuto účtu.",
        "YES": "Ano, deaktivovat ",
        "NO": "Ne, zachovat "
      }
    },
    "EDIT": {
      "TITLE": "Upravit agenta",
      "FORM": {
        "NAME": {
          "LABEL": "Název agenta",
          "PLACEHOLDER": "Zadejte název agenta"
        },
        "AGENT_TYPE": {
          "LABEL": "Typ agenta",
          "PLACEHOLDER": "Vyberte typ",
          "ERROR": "Je vyžadován typ agenta"
        },
        "EMAIL": {
          "LABEL": "E-mailová adresa",
          "PLACEHOLDER": "Zadejte prosím e-mailovou adresu agenta"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Dostupnost",
          "PLACEHOLDER": "Vyberte prosím stav dostupnosti",
          "ERROR": "Dostupnost je vyžadována"
        },
        "API_ACCESS": {
          "LABEL": "Povolit přístup k API",
          "HELP": "Přístup k API je ve výchozím nastavení vypnutý. Zapnutím povolíte použití osobního API klíče tohoto agenta, a to pro všechny účty, do kterých patří. Přihlášení do aplikace to neovlivní."
        },
        "SUBMIT": "Upravit agenta"
      },
      "BUTTON_TEXT": "Upravit",
      "CANCEL_BUTTON_TEXT": "Zrušit",
      "API": {
        "SUCCESS_MESSAGE": "Spolupracující úspěšně aktualizováni",
        "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "Obnovit heslo",
        "ADMIN_SUCCESS_MESSAGE": "E-mail s instrukcemi pro obnovení hesla byl odeslán agentovi",
        "SUCCESS_MESSAGE": "Heslo agenta bylo úspěšně obnoveno",
        "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
      }
    },
    "SEARCH": {
      "NO_RESULTS": "Žádné výsledky."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "Nic",
      "TITLE": {
        "AGENT": "Vybrat agenta",
        "TEAM": "Vybrat tým"
      },
      "LIST": {
        "NONE": "Nic"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "Nenalezeni žádní agenti",
          "TEAM": "Nenalezeny žádné týmy"
        },
        "PLACEHOLDER": {
          "AGENT": "Hledat agenty",
          "TEAM": "Hledat týmy",
          "INPUT": "Hledat agenty"
        }
      }
    }
  }
}